import { UAParser } from 'ua-parser-js';
/**
 * Function that takes in the user agent string and returns a
 * boolean that correlates to user being on mobile or tablet
 */
export var isMobileUserAgent = function isMobileUserAgent(userAgent) {
  // If for some reason user agent does not exist, treat as mobile for header paint optimization
  if (!userAgent) {
    return true;
  }
  var userDeviceType = new UAParser(userAgent).getDevice().type || '';
  // used to determine initial "guess" for SSR: https://github.com/ReactTraining/react-media#server-side-rendering-ssr
  var isMobileUA = ['mobile', 'wearable', 'embedded'].includes(userDeviceType);
  var isMobileOrTabletUA = isMobileUA || userDeviceType === 'tablet';
  return isMobileOrTabletUA;
};
export default isMobileUserAgent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/utils/isMobileUserAgent.js
// module id = 4597
// module chunks = 11